import styled from 'styled-components';

export const StyledTitle = styled.h3`
  color: ${props => props.theme.whitelabel?.text_primary_color};
  text-align: center;
  margin-bottom: 1.25rem;
`;

export const Text = styled.span`
  color: ${props => props.theme.whitelabel?.text_primary_color};
`;

export const CheckboxLabel = styled.label`
  color: ${props => props.theme.whitelabel?.text_primary_color};
  font-size: 0.75rem;
`;

export const CardBorder = styled.div`
  border-bottom: 1px solid ${props => props.theme.whitelabel?.text_primary_color};
`;